import type { Logger } from "@expert/logging";
import type { ReactiveMessagePayload } from "@expert/shared-types";

import { useReactAnalytics } from "@asurion-core/eventualize-react";
import { type GaiaWebSocketResponse, gaiaWsEventBus, isAutoCompleteMessage } from "@expert/gaia";
import { trackFullStoryEvent } from "@expert/monitoring";
import { useEffect, useMemo } from "react";

import { useTimelineStore } from "../state";

export const useGaiaAutoCompleteEvents = (loggerProp: Logger) => {
    const logger = useMemo(() => loggerProp.child({ module: "useGaiaAutocompleteEvents" }), [loggerProp]);
    const { dispatcher } = useReactAnalytics();

    useEffect(() => {
        const gaiaEventBusFetchAutoCompleteSuccess = gaiaWsEventBus.on(
            "gaia_ws_orchestrator-invoke-success",
            ({ body }: GaiaWebSocketResponse) => {
                if (!isAutoCompleteMessage(body as ReactiveMessagePayload)) return;
                const { suggestions, sessionGroupId } = (body ?? {}) as ReactiveMessagePayload;
                logger.info({ suggestions }, "GAIA | AutoComplete | websocket received autocomplete suggestion(s)");

                void dispatcher.dispatchBusinessEvent("AutoComplete_SuggestionReceived", {
                    suggestions,
                });
                trackFullStoryEvent("AutoComplete_SuggestionReceived", { suggestions });

                const parsedSuggestions = suggestions?.map(({ text }) => text);
                const dedupedSuggestions = [...new Set(parsedSuggestions)];

                useTimelineStore.getState().setNewSuggestions(sessionGroupId, dedupedSuggestions);
            },
        );

        return () => {
            gaiaEventBusFetchAutoCompleteSuccess();
        };
    }, [dispatcher, logger]);
};
